export default {
  clients: [],
  client: undefined,
};
